'use client'

import { ThemeProvider as NextThemeProvider } from 'next-themes'
import { PropsWithChildren } from 'react'

import { Theme, ThemeProps } from '@radix-ui/themes'
import '@radix-ui/themes/styles.css'

type TProps = PropsWithChildren<{
    /** Theme used before the user picks one: 'light' | 'dark' | 'system' (default). */
    defaultTheme?: string
    accentColor?: ThemeProps['accentColor']
    grayColor?: ThemeProps['grayColor']
    panelBackground?: ThemeProps['panelBackground']
}>

const ThemeProvider = ({ children, defaultTheme = 'system', accentColor = 'blue', grayColor = 'sand', panelBackground }: TProps) => (
    <Theme accentColor={accentColor} grayColor={grayColor} panelBackground={panelBackground} radius="small" scaling="95%">
        <NextThemeProvider attribute="class" defaultTheme={defaultTheme}>
            {children}
        </NextThemeProvider>
    </Theme>
)

export default ThemeProvider
